import { addNamespace } from '@muz/jobboard-vue-client/src/store/helper/namespace';

const namespace = 'ActionDrawer';

const Types = {
    mutations: {
        SET_OPEN: 'setOpen',
        SET_CONTENT_COMPONENT: 'setComponentComponent',
    },
};

export const LocalTypes = {
    ...Types,
    namespace,
};

export default {
    ...addNamespace(namespace, Types),
    namespace,
};
